// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5194ed81","404":"6594f93c","496":"c0a8f056"}[chunkId] + ".chunk.js";
};